<main id="content" role="main" class="main">
   
    <div class="content container">
        <div >
            <nav aria-label="breadcrumb">
                <ol id="w0" class="breadcrumb">
                    <li class="breadcrumb-item"><a href="/">{{'home'|translate}}</a></li>
                    <li class="breadcrumb-item active" aria-current="page">{{'e-service'|translate}}</li>
                </ol>
            </nav>
        </div>
        <div class="container">
            <div class="row row-cols-1 justify-content-center" >
                <div class="col-md-4 mb-3 mb-lg-5" *ngFor="let item of sections;let index=index">

                    <div class="card card-hover-shadow text-center h-100">
                        <div class="card-progress-wrap">

                            <div class="progress card-progress">
                                <div class="progress-bar {{colorArr[index]}}" role="progressbar" style="width: 100%"
                                    aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>

                        </div>

                        <div class="card-body">
                            <div class="d-flex justify-content-center mb-2">

                                <img class="avatar avatar-lg" [src]="imagesArr[index]" alt="Image Description">
                            </div>
                            <div class="mb-4">
                                <h2 class="mb-1 {{textColorArr[index]}}">
                                    {{item.name}}
                                </h2>
                                <span class="fs-5">
                                </span>
                            </div>
                        </div>


                        <div class="card-footer">

                            <div class="row col-divider">
                                <div class="col">
                                    <a class="btn btn-outline-gold-2" routerLink="/Services"  [queryParams]="{
                                        SectionId:item.id,
                                        MainSectionId:sectionId,
                                        index:index
                                    }">{{'viewService'|translate}} <i
                                            class="bi-arrow-left fs-2"></i></a>
                                </div>


                            </div>

                        </div>

                    </div>

                </div>
        
            </div>
        </div>
    </div>

</main>

<!-- 
<main id="content" role="main" class="main" *ngIf="prod==true">

    <div class="content container">
        <div >
            <nav aria-label="breadcrumb">
                <ol id="w0" class="breadcrumb">
                    <li class="breadcrumb-item"><a href="/">{{'home'|translate}}</a></li>
                    <li class="breadcrumb-item active" aria-current="page">{{'e-service'|translate}}</li>
                </ol>
            </nav>
        </div>
        <div class="container">
            <div class="row row-cols-1 justify-content-center" >
                <div class="col-md-4 mb-3 mb-lg-5" *ngFor="let item of sections;let index=index">

                    <div class="card card-hover-shadow text-center h-100">
                        <div class="card-progress-wrap">

                            <div class="progress card-progress">
                                <div class="progress-bar {{colorArr[index]}}" role="progressbar" style="width: 100%"
                                    aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>

                        </div>

                        <div class="card-body">
                            <div class="d-flex justify-content-center mb-2">

                                <img class="avatar avatar-lg" [src]="imagesArr[index]" alt="Image Description">
                            </div>
                            <div class="mb-4">
                                <h2 class="mb-1 {{textColorArr[index]}}">
                                    {{item.name}}
                                </h2>
                                <span class="fs-5">
                                </span>
                            </div>
                        </div>


                        <div class="card-footer">

                            <div class="row col-divider">

                                <ng-container *ngIf="index==0 || index==1 || index==2 || index==3 || index== 4 || index==5 || index==6  || index ==7 || index ==8   || index ==9;else other_content" >

                                    <div class="col">
                                        <a class="btn btn-outline-gold-2" routerLink="/Services"  [queryParams]="{
                                            SectionId:item.id,
                                            MainSectionId:sectionId,
                                            index:index
                                        }">{{'viewService'|translate}} <i
                                                class="bi-arrow-left fs-2"></i></a>
                                    </div>

                                </ng-container>

                                <ng-template #other_content>

                                    <div class="col">
                                        <a class="btn btn-outline-gold-2" (click)="openSection(index)" >عرض الخدمات <i
                                                class="bi-arrow-left fs-2"></i></a>
                                    </div>
                                    
                                </ng-template>

                                


                            </div>

                        </div>

                    </div>

                </div>
            
          
   
         
            </div>
        </div>
    </div>

</main>   -->